import WHOWEARE_SLIDER1 from './whoweare/slider1en.jpg';
import WHOWEARE_SLIDER2 from './whoweare/slider2en.jpg';
import WHOWEARE_SLIDER3 from './whoweare/slider3en.jpg';
import WHOWEARE_SLIDER4 from './whoweare/slider4en.jpg';
import WHOWEARE_SLIDER5 from './whoweare/slider5en.jpg';
import WHOWEARE_CARD1 from './whoweare/card1.png';
import WHOWEARE_CARD2 from './whoweare/card2.png';
import WHOWEARE_CARD3 from './whoweare/card3.png';
import WHOWEARE_CARD4 from './whoweare/card4.png';
import WHOWEARE_CARD5 from './whoweare/wave2thefuture.png';
import WHOWEARE_CARD6 from './whoweare/shift2DC.png';
import WHOWEARE_CARD7 from './whoweare/progettoEPC.png';
import WHOWEARE_CARD8 from './whoweare/sea2demo.png';
import WHOWEARE_CARD9 from './whoweare/fitfor55.png';

export const homeEn = () => [
  {
    title: 'model',
    internalTitle: 'Home',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'slogan',
          value: 'OPERATING MODEL',
          richText: '',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'text',
          value: 'KEY ROLES AND RESPONSIBILITIES',
          richText:
            '<p><strong>incantieri SI plays the role of System Integrator directly handling, directly handling key activities:</strong></p><ul><li>Engineering;</li><li>Project management;</li><li>Approvals and Purchasing (incl. supply chain management);</li><li>Cost management and evaluation;</li><li>Commissioning.</li></ul><p>Thanks to the close relationship with the most recognized Universities and Research Centers in the sector, <strong>FINCANTIERI SI</strong>provides top technologies and innovation for technical solutions that are always up to date on the market.</p><p><strong>FINCANTIERI SI</strong> makes use of high levelled <strong>existing skills</strong> of the <strong>Fincantieri Group</strong> to propose the activities of:</p><ul><li><strong>System integrator</strong> (technical project management, technical coordination with suppliers, design &amp; engineering, programming);</li><li><strong>Assembly supervisor</strong> (FAT / HAT / SAT and commissioning supervision).</li></ul><p><strong>FINCANTIERI SI </strong>can also count on a consolidated network of suppliers, able to meet the most stringent requirements.</p><p><br></p>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'procedures',
    status: 'draft',
    id: '60a38556a09e3808e5fd8647',
    original: '60a383b4a09e3808e5fd863a',
    createdBy: '5fd33ab1be673ff370b4957e',
    updatedBy: null,
    createdAt: '2021-05-18T09:13:58.285Z',
    updatedAt: '2021-05-18T09:13:58.304Z',
    expireAt: null,
    revision: 2,
    active: true,
    featured: null,
    channelFeatured: null,
    roles: ['ADMIN', 'TECH', 'EDITOR'],
  },
  {
    title: 'home',
    internalTitle: 'Home',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'slogan',
          value: '',
          richText:
            '<p>DEVELOPMENT OF SYSTEMS, TECHNOLOGIES, AND SOLUTIONS AIMED AT ENSURING ENVIRONMENTAL RESPECT</p>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'text',
          value: '',
          richText:
            '<p style="text-align: justify; "><strong>FINCANTIERI SI Spa</strong>, is an Italian company belonging to the Fincantieri Group,that provides innovative and green solutions to ensure sustainability and respect for the environment in the marine field and industrial sector.<br></p>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'home',
    status: 'draft',
    id: '60a7add62d582f4a7633034c',
    original: '60911de9d5b4fe324d3910c5',
    createdBy: '5fd33ab1be673ff370b4957e',
    updatedBy: null,
    createdAt: '2021-05-21T12:55:50.390Z',
    updatedAt: '2021-05-21T12:55:50.404Z',
    expireAt: null,
    revision: 5,
    active: true,
    featured: null,
    channelFeatured: null,
    roles: ['ADMIN', 'TECH', 'EDITOR'],
  },
  {
    title: 'mission',
    internalTitle: 'Home',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'text1',
          value: 'MISSION & VALUES',
          richText:
            '<p class="MsoListParagraphCxSpFirst" style="margin-left: 0cm;"><span lang="EN-US">The\nmission of <strong>FINCANTIERI SI</strong> is to supply full electric power control and\nautomation systems within the marine, infrastructure, and industry segments,\nacting as components integrator of key elements or\ncomplete systems on a turnkey basis.</span></p><p class="MsoListParagraphCxSpFirst" style="margin-left: 0cm;"><span lang="EN-US"><br></span><span lang="EN-US" style="line-height: 107%;"><strong>FINCANTIERI SI</strong></span><span lang="EN-US" style="line-height: 107%;"> aims to be a reference Company in the European\nand Global market in implementing «green» solutions and technologies, to\ngrant sustainable and environmentally friendly development in the naval and\nindustrial field, making use of the know-how developed by Fincantieri Group\nover the years</span></p>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'text3',
          value: '',
          richText:
            '<p class="MsoNormal"><span style="letter-spacing: 0.01em;">\nShipowners need to adopt countermeasures to comply with those guidelins\n:</span><br></p><ul><li><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">Reduce&nbsp;</span><span style="font-weight: 700; font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">CO2</span><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">&nbsp;emissions by at least&nbsp;</span><span style="font-weight: 700; font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">40% by 2030</span><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">;</span></li><li><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">Continue efforts towards&nbsp;<span style="font-weight: 700; letter-spacing: 0.14px;">70%</span><span style="letter-spacing: 0.14px;">&nbsp;</span><span style="font-weight: 700; letter-spacing: 0.14px;">by 2050</span><span style="letter-spacing: 0.14px;">;</span></span></li><li><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;"><span style="letter-spacing: 0.14px;">To reduce total annual&nbsp;<span style="font-weight: 700; letter-spacing: 0.14px;">GHG emissions</span><span style="letter-spacing: 0.14px;">&nbsp;at least&nbsp;</span><span style="font-weight: 700; letter-spacing: 0.14px;">50% by 2050</span><span style="letter-spacing: 0.14px;">&nbsp;compared to 2008 levels.</span></span></span></li></ul>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'text4',
          value: '',
          richText:
            '<p class="MsoNormal" style="text-align: justify; "><span lang="EN-US">In the\nmarine sector, <strong>FINCANTIERI SI</strong> wants to be a leader on the\ndecarbonization.</span></p><p class="MsoNormal" style="text-align: justify; "><span lang="EN-US">Our every-day commitment is devoted to save the planet&nbsp;<o:p></o:p></span></p>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'text5',
          value: '',
          richText:
            '<p class="MsoNormal" style="text-align: justify; ">As part of <strong>Fincantieri Group</strong>, we aspire to be world leaders in the industry where we operate, becoming a reference point for our customers, always selecting high value-added sectors and standing out for our diversification and innovation.<o:p></o:p></p><p class="MsoNormal" style="text-align: justify; ">The Sea Ahead: this is the path shared by all people who work for the <strong>Gruppo Fincantieri</strong>: talented men and women working responsibly and ethically every day to help develop our idea of a future increasingly, innovative, high-performance and sustainable<o:p></o:p></p><p class="MsoNormal" style="text-align: justify; ">Technological growth and continuous improvement are the goals that we have set for ourselves, and we are determined to pursue them.<o:p></o:p></p><p>\n\n</p><p class="MsoNormal" style="text-align: justify; ">Our every action, project, initiative or decision is based on strict compliance with the law, protection of employees and defense of the environment, safeguarding the interests of our shareholders, employees, clients, trade and financial partners, local communities and groups, creating value for every stakeholder.<o:p></o:p></p>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'title',
          value: 'VISION FOR THE FUTURE',
          richText: '',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'text2',
          value: '',
          richText:
            '<p style="text-align: justify; "><span style="letter-spacing: 0.14px;">In April 2018 the&nbsp;</span><span style="font-weight: 700; letter-spacing: 0.14px;">IMO (International Maritime Organization)</span><span style="letter-spacing: 0.14px;">&nbsp;adopted an ambitious program to drastically reduce&nbsp;</span><span style="font-weight: 700; letter-spacing: 0.14px;">GHG (Greenhouse Gases)</span><span style="letter-spacing: 0.14px;">&nbsp;emissions. This program has an imoportant impacts on costs, resources and profits more significantly than in the past.</span><br></p>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'central',
          value: '',
          richText: '',
          image: {
            small: {
              id: '60abbcae2d582f4a76330d4e',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'visionTitle',
          value: 'OUR VISION FOR AN ECO-SUSTAINABLE FUTURE',
          richText: '',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'mission',
    status: 'draft',
    id: '60b4e010de796b74d9178375',
    original: '60a3cfd3a09e3808e5fd88df',
    createdBy: '5fd33ab0be673ff370b4957a',
    updatedBy: null,
    createdAt: '2021-05-31T13:09:36.081Z',
    updatedAt: '2021-05-31T13:09:36.112Z',
    expireAt: null,
    revision: 8,
    active: true,
    channelFeatured: null,
    roles: ['ADMIN', 'TECH'],
  },
  {
    title: 'aboutUs',
    internalTitle: 'Home',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'text',
          value: 'WHO WE ARE',
          richText:
            '<div style=""><p style=""><span lang="EN-US" style=""><strong>FINCANTIERI SI Spa</strong></span><span lang="EN-US" style="">, is an Italian company belonging to the Fincantieri Group, and provide innovative and green solutions to ensure sustainability and respect for the environment in the marine field and industrial sector.</span></p>\n\n\n\n<p style="text-align: justify;"><span lang="EN-US" style=""></span> </p>\n\n\n\n<p style=""><span lang="EN-US" style="">The company was founded in 2015 with head office in Trieste; the main operating site is based in Milan while the design and industrial engineering department is based in Marghera (Venice). The Company count other operative units based in Genova (IT) and in Aix en Provence (FR).</span></p>\n\n\n\n<p style="text-align: justify;"><span lang="EN-US" style=""></span> </p>\n\n\n\n<p style=""><span lang="EN-US" style="">The offered solutions include turnkey integrated electrical, electronic and electromechanical systems, by applying engineering and construction skills already developed in the field of shipbuilding.</span></p>\n\n\n\n<p style="text-align: justify;"><span lang="EN-US" style=""></span> </p>\n\n\n\n<p style=""><span lang="EN-US" style="">We can therefore supply electrict Substations, solutions for harbor infrastructures such as ship to shore power systems, marine solutions for fully electric, hybrid electric/mechanical propulsion and also battery-based energy storage systems.</span></p>\n\n\n\n<p style="text-align: justify;"><span lang="EN-US" style=""></span> </p>\n\n\n\n<p style=""><span lang="EN-US" style=""><strong>FINCANTIERI SI</strong> </span><span lang="EN-US" style="">plays the role of main contractor, directly handling the key activities such as Project management, Procurement execution, supply chain management, and cost controlling.</span></p>\n\n\n\n<p style="text-align: justify;"><span lang="EN-US" style=""></span> </p>\n\n\n\n<p style=""><span lang="EN-US" style=""><strong>FINCANTIERI SI</strong> </span><span lang="EN-US" style="">also operates in the field of civil engineering, mainly providing design for civil works, complex industrial plants, maritime and port infrastructure and electromechanical works.</span></p></div>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'card',
          value: 'https://www.ech2a.eu/',
          richText:
            '<p class="MsoListParagraph" style="margin-left:0cm;mso-add-space:auto;text-align:\njustify">The <strong>European Clean Hydrogen Alliance</strong> aims at an ambitious deployment of hydrogen technologies by 2030, bringing together renewable and low-carbon hydrogen production, demand in industry, mobility and other sectors, and hydrogen transmission and distribution. <o:p></o:p></p>',
          image: WHOWEARE_CARD1,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'card',
          value:
            'https://www.globalmaritimeforum.org/getting-to-zero-coalition',
          richText:
            '<p class="MsoListParagraph" style="margin-left:0cm;mso-add-space:auto;text-align:\njustify">Viable <strong>Zero Emissions Vessels</strong> operating by 2030, supported by the necessary infrastructure for scalable zero-carbon energy sources including production, distribution, storage and bunkering.<br></p>',
          image: WHOWEARE_CARD2,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'card',
          value:
            'https://www.porto.trieste.it/eng/port-authority/eu-projects/ealing',
          richText:
            '<p class="MsoNormal" style="text-align:justify">The <stron>EALING</strong> project aims to develop a feasibility study for the transition to electrification for 16 EU maritime ports involved in the consortium in different sea basins that decided to adapt to the new regime of alternative fuels utilization in the maritime sector.<o:p></o:p></p>',
          image: WHOWEARE_CARD3,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'card',
          value: 'https://seabat-h2020.eu/',
          richText:
            '<p class="MsoNormal" style="text-align:justify">The <strong>SEABAT</strong> project is a consortium to develop a full-electric maritime hybrid concept, with the aim to reduce component costs (battery, convertor) so that unique ship designs can profit from economies of scale by using standardized low-cost modular components. The concept will be suitable for future battery generations and high-power components.<o:p></o:p></p>',
          image: WHOWEARE_CARD4,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'card',
          value: '',
          richText:
            '<p class="MsoListParagraph" style="margin-left:0cm;mso-add-space:auto;text-align:\njustify">Fincantieri has launched <strong>“Wave 2 the Future”</strong>, an IPCEI (Important Project of Common European Interest) project aimed at creating a hybrid propulsion system consisting of fuel cells and an alternative engine. The project includes the design and development of a hydrogen-powered combined cycle for electricity generation, which will subsequently be certified and integrated into two cruise ships. Through this project, we aim to create an innovative production chain for the use of hydrogen in the naval sector, with the Group itself acting as the lead partner.<o:p></o:p></p>',
          image: WHOWEARE_CARD5,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'card',
          value: 'https://shift2dc.eu/',
          richText:
            '<p class="MsoListParagraph" style="margin-left:0cm;mso-add-space:auto;text-align:\njustify">The <strong>Shift2DC Horizon Europe</strong> introduces a new approach on the way direct current (DC) solutions are used in power systems by creating smarter, more efficient, and eco-friendly energy systems. Focusing on the integration of DC solutions in four main infrastructures – Datacenters, Ports, Buildings, and Industry – Shift2DC expects to reshape the way we use electricity.<o:p></o:p></p>',
          image: WHOWEARE_CARD6,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'card',
          value:
            'https://www.pesco.europa.eu/project/european-patrol-corvette-epc/',
          richText:
            '<p class="MsoListParagraph" style="margin-left:0cm;mso-add-space:auto;text-align:\njustify">The objective of the <strong>European Patrol Corvette Project</strong> is to design and develop a prototype for a new Class of military ship, named “European Patrol Corvette” (EPC), which allows to host several systems and payloads, in order to accomplish, with a modular and flexible approach, a large number of tasks and missions.<o:p></o:p></p>',
          image: WHOWEARE_CARD7,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'card',
          value: '',
          richText:
            '<p class="MsoListParagraph" style="margin-left:0cm;mso-add-space:auto;text-align:\njustify">As FINCANTIERI SI, we are proud to be the leader of the <strong>SEA2DEMO project – Shipboard Electrical Advanced Ac/Dc DEMOnstrator</strong> and to collaborate with prestigious partners such as THREAD – Software Development for Industrial Automation, the University of Trieste, and D-Etech. The objective of the project is to reduce emissions by integrating a DC distribution system, which will enable more efficient management of the energy flow, the integration of variable-speed generators, batteries, and Fuel Cells, following the sustainable innovation path set by the Fincantieri Group.<o:p></o:p></p>',
          image: WHOWEARE_CARD8,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'card',
          value: '',
          richText:
            '<p class="MsoListParagraph" style="margin-left:0cm;mso-add-space:auto;text-align:\njustify">The objective of the project is to align the European maritime sector with the EU\'s <strong>"Fit for 55"</strong> targets through cost-effective Energy Efficiency Technologies (EETs), as well as to evaluate new ship designs and retrofits, integrating a decision support system for rapid assessment. It aims to minimize environmental impacts across the entire lifecycle of the ship, from construction to decommissioning, using Lifecycle Analysis (LCA).<o:p></o:p></p>',
          image: WHOWEARE_CARD9,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'title',
          value: '',
          richText: '<p>PARTNERSHIPS</p>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider1',
          value: '',
          richText: '',
          image: WHOWEARE_SLIDER1,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider2',
          value: '',
          richText: '',
          image: WHOWEARE_SLIDER2,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider3',
          value: '',
          richText: '',
          image: WHOWEARE_SLIDER3,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider4',
          value: '',
          richText: '',
          image: WHOWEARE_SLIDER4,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider5',
          value: '',
          richText: '',
          image: WHOWEARE_SLIDER5,
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'aboutus',
    status: 'draft',
    id: '60b4e201de796b74d91783bf',
    original: '60a3c505a09e3808e5fd8789',
    createdBy: '5fd33ab1be673ff370b4957e',
    updatedBy: null,
    createdAt: '2021-05-31T13:17:53.218Z',
    updatedAt: '2021-05-31T13:17:53.235Z',
    expireAt: null,
    revision: 6,
    active: true,
    channelFeatured: null,
    roles: ['EDITOR', 'ADMIN', 'TECH'],
  },
];
